/** A stable id for this browser/device, used to register it to a counter. */
const KEY = 'zpos_device_id';
const NAME_KEY = 'zpos_device_name';

export function getDeviceId(): string {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`).replace(/-/g, '');
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function getDeviceName(): string {
  return localStorage.getItem(NAME_KEY) || `${navigator.platform || 'PC'} – ${navigator.userAgent.includes('Android') ? 'Android' : 'Browser'}`;
}

export function setDeviceName(name: string) {
  localStorage.setItem(NAME_KEY, name);
}

/** Remembered shop code for the login screen. */
export const LAST_SHOP_KEY = 'zpos_last_shop';
